import { OlduserComponent } from './../olduser/olduser.component';
import { MatDialog } from '@angular/material/dialog';
import { AppconfigService } from './../service/appconfig.service';
import { UntypedFormControl } from '@angular/forms';
import { ReturnStatus } from './../class/return-status';
import { StudentevaluationService } from './../service/studentevaluation.service';
import { Listitem } from './../class/listitem';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { LoadCollegeData } from '../class/LoadCollegeDataPojo';
import { NgxSpinnerService } from 'ngx-spinner';
import { AfterViewChecked } from '@angular/core';
import { JilabaAesED } from '../common/JilabaAesED';
import { JilabaKeyEnum } from '../common/JilabaKeyEnum';

interface graduation {
  value: string;
  name: string;
}
@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
  encapsulation: ViewEncapsulation.None,
})


export class MainComponent implements AfterViewChecked,OnInit {
  currentYear = new Date("YYYY");
  clgtype: string;
  clgcode: string;
  collegedata: LoadCollegeData = new LoadCollegeData();
  lstcollege: Array<Listitem> = new Array<Listitem>();
  lstcollegedata: Array<LoadCollegeData> = new Array<LoadCollegeData>();
  college: Listitem = new Listitem();
  blnjobfair : boolean = false;

  listgraduation: graduation[] = [
    { value: 'E', name: 'Engineering' },
    { value: 'P', name: 'Polytechnic' },
    { value: 'A', name: 'Arts and Science' }
  ];
  returnstatus: ReturnStatus = new ReturnStatus();
  panelColor = new UntypedFormControl('red');
  testdate: string;

  constructor(private studentevaluation: StudentevaluationService, private router: Router, public dialog: MatDialog, private spinner: NgxSpinnerService) {
    this.clgtype = 'E';
    // this.jobfairChange();
  }
  ngOnInit(): void {
    this.clgtype = 'E';
   sessionStorage.removeItem("clgtype");
  }
  ngAfterViewChecked(): void {

  }


  async selectPremises(value:any){
    AppconfigService.clgcode = null;
    if (value == 'E') {
      this.blnjobfair=false;
      this.clgtype='E';
      sessionStorage.setItem('clgtype', this.clgtype);
    } else {
        this.blnjobfair=true;
        this.clgtype=value;
      sessionStorage.setItem('clgtype', this.clgtype);
      await this.loadclg(this.clgtype);
    }   
  }

  async loadclg(data: String){
    try {
      if(new String(data) instanceof String)
      {
        this.clgtype = data.toString();
        this.collegedata = new LoadCollegeData();
        this.testdate = '';
        console.log(this.clgtype);
        let map:any={
          "clgtype":this.clgtype,
          "tocken":JilabaAesED.Encrypt(this.clgtype,JilabaKeyEnum.CommonKey)
        }        
        this.returnstatus = await this.studentevaluation.loadclg(map).toPromise();
        if (this.returnstatus.status === true) {
          this.lstcollege = this.returnstatus.returnObject;
        }
      }
      
    } catch (error) {   
      console.log(error.message)
      alert(error.message);
    }

  }

  loadclgData() {
    if(!this.college.value){
      return;
    }

    let map:any={
      "clgcode":this.college.value.toString(),
      "tocken":JilabaAesED.Encrypt(this.college.value.toString(), JilabaKeyEnum.CommonKey)
    }
    
    this.studentevaluation.loadclgData(map).subscribe(data => {
      try {
        this.returnstatus = data;
        if (this.returnstatus.status === true) {

          this.lstcollegedata = this.returnstatus.returnObject;
          this.collegedata = this.lstcollegedata[0];
          this.testdate = 'on ' + this.collegedata.examdate;
          AppconfigService.studentcount = this.collegedata.studentno.toString();
        }

      } catch (error) { 
        alert(error.message);
      }
    });
  }

  setclgcode() {
    if (this.college.value !== undefined) {
      this.clgcode = this.college.value.toString();
      this.loadclgData();
      AppconfigService.clgcode = this.clgcode;
      AppconfigService.clgname = this.college.text;
    }
 
  }

  navigateNew() {
    if(this.blnjobfair){
      AppconfigService.clgcode = "JS";
      AppconfigService.clgname = "JILABA SOFTWARE SERVICES";

      let map:any={
        "clgcode":"JS",
        "tocken":JilabaAesED.Encrypt("JS", JilabaKeyEnum.CommonKey)
      }
      
      this.studentevaluation.loadclgData(map).subscribe(data => {
        try {
          this.returnstatus = data;
          if (this.returnstatus.status === true) {
  
            this.lstcollegedata = this.returnstatus.returnObject;
            this.collegedata = this.lstcollegedata[0];
            this.testdate = 'on ' + this.collegedata.examdate;
            AppconfigService.studentcount = this.collegedata.studentno.toString();
          }
  
        } catch (error) { 
          alert(error.message);
        }
      });
    }
    if (AppconfigService.clgcode === undefined || AppconfigService.clgcode === null) {
      alert('Select College To Proceed Further...');
      document.getElementById('clgcombo').focus();
    } else {
      sessionStorage.setItem('clgtype', this.clgtype);
      // this.router.navigate(['/policies']);
      this.router.navigate(['/studentreg']);
    }
  }

  navigateOld() {
    const dialogRef = this.dialog.open(OlduserComponent, {
      // width: '200px',
      // height: '160px'
    });
  }

}
